/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./global-nav.vue?vue&type=template&id=91bb5002&"
import script from "./global-nav.vue?vue&type=script&lang=js&"
export * from "./global-nav.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./global-nav.vue?vue&type=style&index=0&id=91bb5002&prod&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports